import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getVariantPath } from '@uswitch/spark.utils';
import { BiCheck } from '@uswitch/spark-icons/bi';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDropdownContext } from './context';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var variantPath = getVariantPath({
  id: 'dropdown',
  element: 'item'
});
export var DropdownItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'li' : _ref$as,
      value = _ref.value,
      checked = _ref.checked,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["as", "value", "checked", "children"]);

  var _useDropdownContext = useDropdownContext(),
      selected = _useDropdownContext.selected,
      handleSelect = _useDropdownContext.handleSelect;

  var _useState = useState(checked),
      _useState2 = _slicedToArray(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  useEffect(function () {
    setIsChecked(selected && selected.value === value);
  }, [selected, value]);
  return _jsx(As, _objectSpread(_objectSpread({}, props), {}, {
    onClick: function onClick(e) {
      return handleSelect(value, children, e);
    },
    onKeyUp: function onKeyUp(e) {
      return (e.code === 'Enter' || e.code === 'Space') && handleSelect(value, children, e);
    },
    checked: selected && selected.value === value,
    ref: ref,
    role: "none",
    sx: {
      variant: variantPath('base', 'wrapper')
    },
    children: _jsxs("label", {
      role: "presentation",
      tabIndex: 0,
      sx: {
        variant: variantPath(isChecked ? 'checked' : 'base'),
        ':hover, ._force-hover &': {
          variant: variantPath('hover')
        },
        ':focus, :focus-within, ._force-focus &': {
          variant: variantPath('focus')
        },
        ':checked, ._force-checked &': {
          variant: variantPath('checked')
        },
        ':disabled, ._force-disabled &': {
          variant: variantPath('disabled')
        }
      },
      children: [_jsx("input", {
        role: "menuitemcheckbox",
        type: "checkbox",
        tabIndex: -1,
        checked: checked,
        onChange: function onChange() {
          return setIsChecked(!isChecked);
        },
        "aria-checked": checked,
        disabled: false,
        sx: {
          position: 'absolute',
          opacity: 0
        }
      }), children, isChecked && _jsx(BiCheck, {
        sx: {
          variant: variantPath('base', 'icon')
        }
      })]
    })
  }));
});
DropdownItem.propTypes = {
  /**
   * Item value
   */
  value: PropTypes.string,

  /**
   * If item should be precheked you can use this prop
   */
  checked: PropTypes.bool
};
DropdownItem.defaultProps = {
  value: '',
  checked: false
};
DropdownItem.displayName = 'DropdownItem';